import Alert from "@mui/material/Alert";
import {MAX_SHARE_RECIPIENTS} from "./shareLimits";

/**
 * Tells the user that the share has more recipients than the backend accepts (DE-1843). Renders nothing within the limit.
 *
 * @param {number} count - How many recipients are chosen.
 * @param {Function} t - The caller's translation function.
 */
export const TooManyRecipientsAlert = ({count, t}) => count > MAX_SHARE_RECIPIENTS && (
    <Alert severity="error" sx={{mt: 1}}>
        {t(
            "shareTooManyRecipients",
            `Du kan dele med høyst ${MAX_SHARE_RECIPIENTS} mottagere om gangen. ${removeInstruction(count - MAX_SHARE_RECIPIENTS)}`,
            {max: MAX_SHARE_RECIPIENTS, excess: count - MAX_SHARE_RECIPIENTS}
        )}
    </Alert>
);

const removeInstruction = (excess) => excess === 1 ? "Fjern 1 mottager." : `Fjern ${excess} mottagere.`;
